import { Field, ID, ObjectType } from 'type-graphql'
import { Chat } from '@ztechapps/common.contract'
import { SupportTicketStatusEnum } from '../enums/SupportTicketStatusEnum'

/**
 * A conversation as the mobile builds that predate conversations read it — the fields their
 * `SupportTicket` documents select, copied off a `Chat` per read. Not persisted: `toSupportTicket`
 * builds it, and `chat` is the conversation itself so its thread resolves through the chat
 * resolvers.
 */
@ObjectType('SupportTicket')
export class SupportTicket {
  @Field(() => ID)
  _id: string

  @Field(() => String, { nullable: true })
  code?: string

  @Field(() => String)
  subject: string

  @Field(() => SupportTicketStatusEnum)
  status: SupportTicketStatusEnum

  @Field(() => Date)
  lastMessageAt: Date

  @Field(() => Chat)
  chat: Chat
}
